<script>
    import { apiUrl } from "@/utils";
    import BaseButton from "@main/packages/BaseButton";

    export default {
        name: "GiftInfo",
        props: {
            certificate: Object,
            activeTemplate: Object,
            form: Object,
            isLoading: Boolean,
            buttonText: String,
        },
        components: {
            BaseButton,
        },
        methods: {
            apiUrl,
            onSubmit() {
                this.$emit("on-submit");
            },
        },
    };
</script>

<template>
    <section class="gift-order gift-section">
        <div class="gift-order__inner">
            <div class="gift-order__main">
                <h2 class="gift-section__title">Оформление покупки</h2>

                <div class="gift-order__row">
                    <div class="gift-order__cell">Номинал сертификата</div>
                    <div class="gift-order__cell">{{ certificate.amount }}&nbsp;₽</div>
                </div>

                <div class="gift-order__row">
                    <div class="gift-order__cell">
                        <span v-if="form.recipientPhone">Телефон получателя</span>
                        <span v-else>Email получателя</span>
                    </div>
                    <div class="gift-order__cell">
                        <span v-if="form.recipientPhone">{{ form.recipientPhone }}</span>
                        <span v-else>{{ form.recipientEmail }}</span>
                    </div>
                </div>

                <div class="gift-order__row">
                    <div class="gift-order__cell">Email отправителя</div>
                    <div class="gift-order__cell">{{ form.senderEmail }}</div>
                </div>

                <div class="gift-order__row">
                    <div class="gift-order__cell">Срок действия карты</div>
                    <div class="gift-order__cell">365 дней</div>
                </div>
            </div>

            <div v-if="activeTemplate" class="gift-order__image">
                <img :src="apiUrl(activeTemplate.image)" alt="" />
                <div class="gift-order__notation">Выбранный дизайн сертификата</div>
            </div>
        </div>

        <base-button
            class="gift-order__button"
            size="md"
            additional-icon="external"
            :is-loading="isLoading"
            @click="onSubmit"
        >
            {{ buttonText }}
        </base-button>
        <div class="gift-order__notation">
            Нажимая кнопку выше, вы принимаете
            <a target="_blank" href="/document-confidentiality">пользовательское соглашение</a>
            и <a href="/certificates" target="_blank">условия использования</a>.
        </div>
    </section>
</template>

<style lang="scss">
    .gift-order__inner {
        margin-bottom: 30px;
        @include bp($bp-desktop-sm) {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 60px;
        }
    }

    .gift-order__main {
        margin-bottom: 30px;
        @include bp($bp-desktop-sm) {
            flex-shrink: 0;
            flex-basis: 480px;
            max-width: 480px;
            margin-bottom: 0;
        }
    }

    .gift-order__image {
        position: relative;
        &::before {
            content: "";
            display: block;
            padding-bottom: 62.8%;
        }
        img {
            @include center-absolute(0);
        }
        @include bp($bp-desktop-sm) {
            flex-shrink: 0;
            flex-basis: 400px;
            max-width: 400px;
        }
        @include bp($bp-desktop-lg) {
            flex-basis: 480px;
            max-width: 480px;
        }
    }

    .gift-order__row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0;
        &:not(:last-child) {
            border-bottom: 1px solid #adbdd2;
        }
        @include bp($bp-desktop-sm) {
            padding: 15px 0;
        }
    }

    .gift-order__cell {
        font-size: 14px;
        line-height: 22px;
        &:last-child {
            font-weight: 600;
        }
        @include bp($bp-desktop-sm) {
            font-size: 18px;
            line-height: 28px;
        }
    }

    .gift-order__button {
        width: 100%;
        @include bp($bp-desktop-sm) {
            width: 360px;
            margin: 0 auto;
        }
    }

    .gift-order__notation {
        margin-top: 5px;
        color: var(--secondary-text);
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        a {
            color: var(--primary-link);
            &:hover {
                text-decoration: underline;
            }
        }
        @include bp($bp-desktop-sm) {
            max-width: 360px;
            margin: 10px auto 0;
        }
    }
</style>
